import { Component, h, Host, Prop } from "@stencil/core";

/**
 * Webinar Info component - used to display information about the webinar
 * this component is used together with the webinar component
 * @slot - The content of the webinar info
 */
@Component({
    tag: "ux-iws-webinar-info",
    styleUrl: "webinar-info.scss",
    shadow: true,
})
export class WebinarInfo {
    /**
     * The name of the item (displayed on top)
     */
    @Prop() name: string;

    render() {
        return (
            <Host>
                <div class="name">{this.name}</div>
                <div class="content">
                    <slot />
                </div>
            </Host>
        );
    }
}
